/* eslint-disable */
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }                = useAuth();
  const navigate                 = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const userData = await login(email, password);
      if (userData.role === 'admin') {
        navigate('/admin');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Email ou mot de passe incorrect');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-wrap">
      <div className="auth-box">
        <div className="auth-logo">Lexback</div>
        <div className="auth-tagline">Bienvenue sur votre espace formalités.</div>
        <div className="auth-title">Se connecter</div>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="loic@legalvision.fr" required />
          </div>
          <div className="field">
            <label>Mot de passe</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>

          {/* Lien mot de passe oublié */}
          <div style={{ textAlign:'right', marginTop:'-6px', marginBottom:'16px' }}>
            <Link to="/forgot-password" style={{ fontSize:'12px', color:'#B8860B', textDecoration:'none' }}>
              Mot de passe oublié ?
            </Link>
          </div>

          <button className="auth-btn" type="submit" disabled={loading}>
            {loading ? 'Connexion...' : 'Se connecter →'}
          </button>
        </form>

        <div className="auth-link">
          Pas encore de compte ?{' '}
          <a href="mailto:contact@swap-business.com">Contactez-nous</a>
        </div>
      </div>
    </div>
  );
}
